import { render, staticRenderFns } from "./MarketplaceDigitalGiftsIndex.vue?vue&type=template&id=6a2658f9&scoped=true&"
import script from "./MarketplaceDigitalGiftsIndex.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDigitalGiftsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2658f9",
  null
  
)

export default component.exports